/**
 * Как задача выглядит: цвет типа и глиф приоритета.
 *
 * Отдельно от компонентов, потому что цвет типа нужен дважды в одной карточке —
 * иконке и полосе слева, — а глиф приоритета появится ещё и в списке задач.
 */
import type { V1IssueType, V1Priority } from '@/api/clients/tracker-issue'

const TYPE_COLORS: Record<string, string> = {
  ISSUE_TYPE_EPIC: 'var(--color-issue-epic)',
  ISSUE_TYPE_STORY: 'var(--color-issue-story)',
  ISSUE_TYPE_TASK: 'var(--color-issue-task)',
  ISSUE_TYPE_BUG: 'var(--color-issue-bug)',
  ISSUE_TYPE_SUBTASK: 'var(--color-issue-subtask)',
}

const TYPE_GLYPHS: Record<string, string> = {
  ISSUE_TYPE_EPIC: '◆',
  ISSUE_TYPE_STORY: '▪',
  ISSUE_TYPE_TASK: '✓',
  ISSUE_TYPE_BUG: '●',
  ISSUE_TYPE_SUBTASK: '↳',
}

/** Цвет типа: им залиты и квадрат иконки, и полоса слева на карточке */
export const typeColor = (type: V1IssueType | ''): string =>
  TYPE_COLORS[type] ?? 'var(--color-text-muted)'

export const typeGlyph = (type: V1IssueType | ''): string => TYPE_GLYPHS[type] ?? ''

/**
 * Приоритет — знак и цвет. В макете четыре глифа (5:21), а в модели пять
 * значений: низший делит вид с низким. Выдумывать пятый знак хуже, чем
 * повторить четвёртый — приоритет ниже низкого встречается раз в квартал, и
 * различает их подпись, а не оттенок серого.
 */
const PRIORITY_GLYPHS: Record<string, { glyph: string; color: string }> = {
  PRIORITY_HIGHEST: { glyph: '!', color: 'var(--color-priority-urgent)' },
  PRIORITY_HIGH: { glyph: '↑', color: 'var(--color-priority-high)' },
  PRIORITY_MEDIUM: { glyph: '=', color: 'var(--color-priority-medium)' },
  PRIORITY_LOW: { glyph: '↓', color: 'var(--color-priority-low)' },
  PRIORITY_LOWEST: { glyph: '↓', color: 'var(--color-priority-low)' },
}

export const priorityVisual = (priority: V1Priority | '') => PRIORITY_GLYPHS[priority] ?? null
